import { Yii } from "libraries/interfaces/Yii";
import { ILabels } from "libraries/interfaces/ILabels";

export const PROCESSING_STATUSES: ILabels = {
    pending: Yii.t('wui-sasha-js', "En attente de traitement"),
    processing: Yii.t('wui-sasha-js', "Traitement en cours"),
    success: Yii.t('wui-sasha-js', "Effectué"),
    warning: Yii.t('wui-sasha-js', "Avertissement"),
    error: Yii.t('wui-sasha-js', "Erreur"),
};